import { List, ListItemButton, ListItemIcon, styled } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { StyledListItemButtonProps, StyledListItemIconProps } from '../../props';

export const ListStyled = styled(List)(({ theme }) => ({
  position: 'relative',
  paddingLeft: '24px',
  '& ::after': {
    content: "''",
    position: 'absolute',
    left: 0,

    top: 0,
    height: '100%',
    width: 1,
    opacity: 0.2,
    backgroundColor: theme.palette.common.white
  }
}));

export const AnimatedCollapse = styled('div')(({ theme }) => ({
  overflow: 'hidden',
  maxHeight: 0,
  opacity: 0,
  transition: `${theme.transitions.create('max-height', { duration: 350, easing: theme.transitions.easing.easeInOut })}, ${theme.transitions.create('opacity', { duration: 250, easing: theme.transitions.easing.easeInOut })}`,
  willChange: 'max-height, opacity',

  '&.expanded, &[data-expanded="true"], &[aria-hidden="false"]': {
    maxHeight: theme.spacing(150),
    opacity: 1
  },

  '&[aria-hidden="true"]': {
    maxHeight: 0,
    opacity: 0
  },

  '@media (prefers-reduced-motion: reduce)': {
    transition: 'none'
  }
}));

export const StyledListItemIcon = styled(ListItemIcon, {
  shouldForwardProp: (prop) => !['level', 'sidebarOpen', 'activeModule', 'iconSelectedColor'].includes(prop as string)
})<StyledListItemIconProps>(({ level, sidebarOpen, activeModule, iconSelectedColor, theme }) => ({
  minWidth: level === 1 ? 36 : 18,
  padding: 0,
  color: iconSelectedColor,
  ...(!sidebarOpen &&
    level === 1 && {
      borderRadius: '8px',
      width: 46,
      height: 46,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: activeModule ? alpha(theme.palette.common.white, 0.08) : 'transparent',
      '&:hover': {
        backgroundColor: alpha(theme.palette.common.white, 0.04)
      },
      ...(activeModule && {
        '&:hover': {
          backgroundColor: alpha(theme.palette.common.white, 0.04)
        }
      })
    })
}));

export const StyledListItemButton = styled(ListItemButton, {
  shouldForwardProp: (prop) => !['level', 'sidebarOpen', 'iconSelectedColor'].includes(prop as string)
})<StyledListItemButtonProps>(({ level, sidebarOpen, iconSelectedColor, theme }) => ({
  zIndex: 1201,
  borderRadius: '8px',
  padding: !sidebarOpen ? 0 : 10,
  marginTop: !sidebarOpen ? 15 : 0,
  '&.MuiListItemButton-root.Mui-selected': {
    backgroundColor: sidebarOpen ? alpha(theme.palette.common.white, 0.08) : 'transparent'
  },

  '&.MuiListItemButton-root:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.04)
  },

  ...(sidebarOpen &&
    level === 1 && {
      '&.Mui-selected': {
        backgroundColor: alpha(theme.palette.common.white, 0.08),
        color: iconSelectedColor
      }
    }),
  ...((sidebarOpen || level !== 1) && {
    py: level === 1 ? 0 : 1,
    '&.Mui-selected': {
      backgroundColor: alpha(theme.palette.common.white, 0.08)
    }
  })
}));
